import UploadFacade from '@/services/tus/UploadFacade';
import Http from '@/services/http';
import {
  AnalysisProcessingRequest,
  PagedRequest,
  AnalysisProcessingPagedResponse,
} from 'sigma-mappings';

const PROCESSING_BASE_URL = '/engenharia/chroma/processamentos';

const processingByIdBaseUrl = processingId => `${PROCESSING_BASE_URL}/${processingId}`;

export const UPLOAD_ALLOWED_FILE_TYPES = ['.xls', '.xlsx'];

const urls = {
  upload: '/engenharia/chroma/arquivos',
  startProcessing: processingId => `${processingByIdBaseUrl(processingId)}/processar`,
  cancelProcessing: processingId => `${processingByIdBaseUrl(processingId)}/abortar`,
  downloadTemplate: '/engenharia/chroma/template',
  downloadLog: processingId => `${processingByIdBaseUrl(processingId)}/notificacoes/baixar`,
  processingList: `${PROCESSING_BASE_URL}/listagem`,
};

const uploadErrorMessageParams = {
  $ME019: {
    allowedSize: 25,
  },
  $MA066: {},
  $ME017: { allowedExtensionList: UPLOAD_ALLOWED_FILE_TYPES },
};

export default {
  createUploadManager({ listeners, listenersScope }) {
    return new UploadFacade({
      url: urls.upload,
      listeners,
      listenersScope,
      errorHandling: {
        responseMessageParams: uploadErrorMessageParams,
      },
    });
  },
  downloadTemplate() {
    const http = new Http({ download: true });
    return http.get(urls.downloadTemplate);
  },
  startProcessing(processingId, username) {
    const http = new Http();
    return http.post(urls.startProcessing(processingId),
      new AnalysisProcessingRequest({ username }));
  },
  cancelProcessing(processingId) {
    const http = new Http();
    return http.post(urls.cancelProcessing(processingId));
  },
  downloadLog(processingId) {
    const http = new Http({ download: true });
    return http.post(urls.downloadLog(processingId));
  },
  getProcessingList(params) {
    const http = new Http();
    return http.post(urls.processingList,
      new PagedRequest(params))
      .then(({ data }) => new AnalysisProcessingPagedResponse(data));
  },
};
